import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireSrc } from "D:\\work\\openSource\\jspredict-dc\\src\\index.js";
var srcExports = requireSrc();
export { srcExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(srcExports);